module.exports = __webpack_public_path__ + "img/hunt_logo1.5cb6d9f9.png";